export enum MODULE_NAME {
  AUTHENTICATION = "Authentication",
  AUTHORIZATION = "Authorization",
  GENERAL = "General",
  DASHBOARD = "Dashboard",
  USERS = "Users",
  PARTICIPANTS = "Participants",
  PARTICIPANTS_LIST = "Participants list",
  PARTICIPANTS_MANAGE_OFFICERS = "Participant manage officers",
  PARTICIPANTS_MANAGE_SUPPORT_STAFF = "Participant manage support staff",
  PARTICIPANTS_MANAGE_INTERNAL_PROVIDER = "Participant manage internal providers",
  PARTICIPANTS_MANAGE_CASE_PLAN = "Participant manage case plan",
  PARTICIPANT_GOALS = "Participant goals",
  PARTICIPANT_REWARDS = "Participant rewards",
  PARTICIPANT_JOURNALS = "Participant journals",
  SIGN_IN = "Sign in",
  SIGN_OUT = "Sign out",
  CHAT = "Chat",
  SCREENING_COLORS = "Screening colors",
  ORGANIZATION = "OU",
  PROGRAM = "Program",
  ROLES = "Roles",
  ENROLLMENTS = "Enrollments",
  ACTIONS = "Actions",
  EDUCATIONAL_RESOURCES = "Educational Resources",
  SETTINGS = "Settings",
  GROUP_LABEL = "Group Label",
  HOME = "Home",
  VALIDATION = "Validation",
  VALIDATION_CAPTURE = "Validation capture",
  SIGN_UP = "Sign up",
  HOW_TO = "How to",
  REWARDS = "Rewards",
}

export enum OPTIONS {
  // Authentication and Authorization
  SIGN_UP = "Sign up",
  SIGN_IN = "Sign in",
  INACTIVE_ACCOUNT = "Inactive account",

  AUDIT_LOG_VIEW = "Audit log view",
  EMAIL_MATCHING = "Email matching",
  TERMS_AND_CONDITIONS = "T&C",
  VERIFY_CODE = "Verify code",
  SESSION_START = "Session start",
  SIGN_OUT = "Sign out",
  CHANGE_LANGUAGE = "Change language",
  REQUEST_ACCOUNT_DELETION = "Request account deletion",
  USERS_GUIDE = "User’s guide",
  HOME = "Home",
  DASHBOARD = "Dashboard",
  PARTICIPANTS_LIST = "Participants list",
  PARTICIPANT_ADD = "Participant add",
  PARTICIPANT_PROFILE = "Participant profile",
  PARTICIPANT_EDIT = "Participant edit",
  PARTICIPANT_DISMISS = "Participant dismiss",
  MANAGE_OFFICERS = "Manage officers",
  MANAGE_SUPPORT_STAFF = "Manage support staff",
  MANAGE_INTERNAL_PROVIDERS = "Manage internal providers",
  MANAGE_CASE_PLAN = "Manage case plan",
  PARTICIPANT_GOALS_LIST = "Participant goals list",
  WEB_PART_GOAL_ADD = "When added new goal",
  GOAL_FROM_TEMPLATE_TO_PARTICIPANT = "Goal from template to participant",
  EDIT_GOAL_TO_PARTICIPANT = "Edit goal to participant",
  STEP_APPROVAL_TO_PARTICIPANT = "Step approval to participant",
  STEP_REJECTION_TO_PARTICIPANT = "Step rejection to participant",
  PARTICIPANT_JOURNALS_LIST = "Participant journals list",
  PARTICIPANT_JOURNAL = "Participant journal",
  PARTICIPANT_REWARDS_LIST = "Participant rewards list",
  PARTICIPANT_REWARD_REDEMPTION = "Participant reward redemption",
  PARTICIPANT_REWARD_VIEW_DETAIL_FROM_EXTERNAL_PROVIDER = "Participant reward view detail from external provider",
  ADD_INDIVIDUAL_APPOINTMENT = "Add individual appointment",
  EDIT_INDIVIDUAL_APPOINTMENT = "Edit individual appointment",
  ADD_GROUP_APPOINTMENT = "Add group appointment",
  EDIT_GROUP_APPOINTMENT = "Edit group appointment",
  DELETE_APPOINTMENT = "Delete appointment",
  MARK_AS_ABSENT = "Mark as absent",
  REVERT_ABSENCE = "Revert absence",
  LOG_ACTIVITY = "Log activity",
  LOG_WALK_IN_ACTIVITY = "Log walk-in activity",
  IN_HOUSE_SERVICE_ACTIVITY_DETAIL = "In-house service activity detail",
  USERS_LIST = "Users list",
  USER_ADD_EDIT = "User add / edit",
  DELETE = "Delete",
  RESEND_VERIFICATION_LINK = "Resend verification link",
  CHAT_CONTACTS = "Chat contacts",
  CHAT_WINDOW = "Chat window",
  SCREENING_COLORS_VIEW = "Screening colors view",
  SCREENING_COLORS_AUDIT_LOG_VIEW = "Screening colors audit log view",
  SCREENING_COLORS_ADD = "Screening colors add",
  SCREENING_COLORS_EDIT = "Screening colors edit",
  SCREENING_COLORS_DELETE = "Screening colors delete",
  SCREENING_COLORS_BATCH_UPLOAD = "Screening colors batch upload",

  ORGANIZATION_LIST = "OU list",
  ORGANIZATION_ADD = "OU add",
  ORGANIZATION_EDIT = "OU edit",
  ORGANIZATION_DELETE = "OU delete",
  PROGRAM_LIST = "Program list",
  PROGRAM_ADD = "Program add",
  PROGRAM_EDIT = "Program edit",
  PROGRAM_DELETE = "Program delete",
  ROLES_LIST = "Roles list",
  ROLES_ADD = "Roles add",
  ROLES_EDIT = "Roles edit",
  ROLES_DELETE = "Roles delete",
  ROLES_AUDIT_LOG_VIEW = "Roles audit log view",

  ENROLLMENT = "Enrollment",
  ENROLLMENT_DETAIL_TEST = "Enrollment detail - Test results",
  ENROLLMENT_DETAIL_TEST_VAL_RESULT_VIEW = "Enrollment detail - Test results - Validate results",
  ENROLLMENT_ON_DEMAND_INCENTIVES = "On demand incentives",
  INCENTIVES_HISTORY = "Incentives history",

  ACTIONS_LIST = "Actions list",
  ACTIONS_ADD = "Actions add",
  ACTIONS_EDIT = "Actions edit",
  ACTIONS_DELETE = "Actions delete",
  ACTIONS_VIEW = "Actions view",
  ACTIONS_SEARCH = "Actions search",
  VIEW = "View",
  CREATE = "Create",
  EDIT = "Edit",
  SEARCH = "Search",

  GROUP_LABEL_LIST = "Group Label list",
  GROUP_LABEL_CREATE = "Group Label create",
  GROUP_LABEL_EDIT = "Group Label edit",
  GROUP_LABEL_DELETE = "Group Label delete",
  GROUP_LABEL_VIEW = "Group Label view",
  GROUP_LABEL_SEARCH = "Group Label search",

  ON_DEMAND_REQUEST_VALIDATION = "On demand request validation",

  // Export data (backoffice research export)
  EXPORT_DATA_VIEW = "Export data view",
  EXPORT_DATA_SUBMIT = "Export data submit",
}

export enum ACTION_CODE {
  // Authentication and Authorization
  WEB_ONB_SIGNUP = "WEB_ONB_SIGNUP",
  WEB_SIGN_IN_OK = "WEB_SIGN_IN_OK",
  WEB_INVALID_ACCOUNT = "WEB_INVALID_ACCOUNT",

  MOB_SIGNUP_EMAIL_MATCH = "MOB_SIGNUP_EMAIL_MATCH",
  MOB_SIGNUP_TYC_OK = "MOB_SIGNUP_TYC_OK",
  MOB_SIGNUP_TYC_DECLINED = "MOB_SIGNUP_TYC_DECLINED",
  MOB_SIGNUP_ACCOUNT_COMPLETED = "MOB_SIGNUP_ACCOUNT_COMPLETED",
  MOB_SIGNUP_ACCOUNT_REWARD_OK = "MOB_SIGNUP_ACCOUNT_REWARD_OK",
  MOB_SIGNUP_ACCOUNT_REWARD_ERRORED = "MOB_SIGNUP_ACCOUNT_REWARD_ERRORED",
  MOB_SIGNUP_ACCOUNT_REWARD_DEFERRED = "MOB_SIGNUP_ACCOUNT_REWARD_DEFERRED",
  MOB_SIGNUP_PROFILE_UPDATE = "MOB_SIGNUP_PROFILE_UPDATE",
  MOB_SIGNUP_ACCOUNT_CREATED_EMAIL = "MOB_SIGNUP_ACCOUNT_CREATED_EMAIL",
  MOB_SIGNUP_DEMOGRAPHICS_OK = "MOB_SIGNUP_DEMOGRAPHICS_OK",
  MOB_SIGNUP_RESEND_CODE = "MOB_SIGNUP_RESEND_CODE",
  MOB_SESSION_VERIFICATION_CODE_SENT = "MOB_SESSION_VERIFICATION_CODE_SENT",
  MOB_SESSION_RESEND_VERIFICATION_CODE = "MOB_SESSION_RESEND_VERIFICATION_CODE",
  MOB_SIGNIN_SUCCESSFULLY = "MOB_SIGNIN_SUCCESSFULLY",
  MOB_SETTING_CHN_LANG_ENTER = "MOB_SETTING_CHN_LANG_ENTER",
  MOB_SETTING_CHN_LANG_SUBMITTED = "MOB_SETTING_CHN_LANG_SUBMITTED",
  MOB_SETTING_PROFILE_ENTER = "MOB_SETTING_PROFILE_ENTER",
  MOB_SETTING_PROFILE_SAVED = "MOB_SETTING_PROFILE_SAVED",
  MOB_SETTING_DEL_ACCT_ENTER = "MOB_SETTING_DEL_ACCT_ENTER",
  MOB_SETTING_USER_GUIDE_ENTER = "MOB_SETTING_USER_GUIDE_ENTER",
  MOB_HOME_ENTER = "MOB_HOME_ENTER",
  // rewards - COYN-487, COYN-495, COYN-503
  MOB_REWARDS_MAIN_ENTER = "MOB_REWARDS_MAIN_ENTER",
  MOB_REWARDS_REDEEM_SUCCESS = "MOB_REWARDS_REDEEM_SUCCESS",
  MOB_REWARDS_REDEEM_ERROR = "MOB_REWARDS_REDEEM_ERROR",
  // wallet - COYN-650
  MOB_WALLET_ENTER = "MOB_WALLET_ENTER",
  MOB_WALLET_VIEW_GIFT_CARD = "MOB_WALLET_VIEW_GIFT_CARD",
  // validation - COYN-731
  MOB_VALIDATION_INTRO_ENTER = "MOB_VALIDATION_INTRO_ENTER",
  MOB_VALIDATION_CAMERA_ENTER = "MOB_VALIDATION_CAMERA_ENTER",
  MOB_VALIDATION_SUBMIT = "MOB_VALIDATION_SUBMIT",
  // non-carriage - COYN-707
  MOB_NON_CARRIAGE_ENTER = "MOB_NON_CARRIAGE_ENTER",
  MOB_NON_CARRIAGE_SUBMIT = "MOB_NON_CARRIAGE_SUBMIT",
  // how to
  MOB_HOW_TO_LIST_ENTER = "MOB_HOW_TO_LIST_ENTER",
  MOB_HOW_TO_LINK_VIEW = "MOB_HOW_TO_LINK_VIEW",
  MOB_HOW_TO_VIDEO_VIEW = "MOB_HOW_TO_VIDEO_VIEW",
  MOB_HOW_TO_AUDIO_VIEW = "MOB_HOW_TO_AUDIO_VIEW",
  WEB_GEN_LIST_AUDITLOG_VIEW = "WEB_GEN_LIST_AUDITLOG_VIEW",
  WEB_DASHBOARD_VIEW = "WEB_DASHBOARD_VIEW",
  WEB_PART_LIST_VIEW = "WEB_PART_LIST_VIEW",
  WEB_PART_ADD = "WEB_PART_ADD",
  WEB_PART_LIST_SEARCH = "WEB_PART_LIST_SEARCH",
  WEB_PART_ON_DEMAND_REQUEST_VALIDATION = "WEB_PART_ON_DEMAND_REQUEST_VALIDATION",
  WEB_PART_ADD_INVITE = "WEB_PART_ADD_INVITE",
  WEB_PART_PROFILE_VIEW = "WEB_PART_PROFILE_VIEW",
  WEB_PART_EDIT = "WEB_PART_EDIT",
  WEB_PART_DISMISS = "WEB_PART_DISMISS",
  WEB_PART_ADDED_OFFICERS = "WEB_PART_ADDED_OFFICERS",
  WEB_PART_REMOVED_OFFICERS = "WEB_PART_REMOVED_OFFICERS",
  WEB_PART_ADDED_STAFF = "WEB_PART_ADDED_STAFF",
  WEB_PART_REMOVED_STAFF = "WEB_PART_REMOVED_STAFF",
  WEB_PART_ADDED_INT_PROVIDERS = "WEB_PART_ADDED_INT_PROVIDERS",
  WEB_PART_REMOVED_INT_PROVIDERS = "WEB_PART_REMOVED_INT_PROVIDERS",
  WEB_PART_GOAL_LIST_VIEW = "WEB_PART_GOAL_LIST_VIEW",
  WEB_PART_GOAL_ADDED_TEMPLATE = "WEB_PART_GOAL_ADDED_TEMPLATE",
  WEB_PART_GOAL_ADD = "WEB_PART_GOAL_ADD",
  WEB_PART_GOAL_EDIT = "WEB_PART_GOAL_EDIT",
  WEB_PART_GOAL_STEP_APPROVE = "WEB_PART_GOAL_STEP_APPROVE",
  WEB_PART_GOAL_STEP_REJECT = "WEB_PART_GOAL_STEP_REJECT",
  WEB_PART_JOURNAL_LIST_VIEW = "WEB_PART_JOURNAL_LIST_VIEW",
  WEB_PART_JOURNAL_VIEW = "WEB_PART_JOURNAL_VIEW",
  WEB_PART_REWARDS_VIEW = "WEB_PART_REWARDS_VIEW",
  WEB_PART_REWARD_REDEMPTION_APPROVE = "WEB_PART_REWARD_REDEMPTION_APPROVE",
  WEB_PART_REWARD_REDEMPTION_REJECT = "WEB_PART_REWARD_REDEMPTION_REJECT",
  WEB_PART_REWARD_EXT_PROV_DETAIL_VIEW = "WEB_PART_REWARD_EXT_PROV_DETAIL_VIEW",
  WEB_APPT_IND_ADD = "WEB_APPT_IND_ADD",
  WEB_APPT_IND_EDIT = "WEB_APPT_IND_EDIT",
  WEB_APPT_GRP_ADD = "WEB_APPT_GRP_ADD",
  WEB_APPT_DELETE = "WEB_APPT_DELETE",
  WEB_APPT_GRP_REMOVED = "WEB_APPT_GRP_REMOVED",
  WEB_APPT_MARK_ABSENT = "WEB_APPT_MARK_ABSENT",
  WEB_APPT_REVERT_ABSENCE = "WEB_APPT_REVERT_ABSENCE",
  WEB_APPT_LOG_ACTIVITY = "WEB_APPT_LOG_ACTIVITY",
  WEB_INHSE_LOG_WALKIN_ACTIVITY = "WEB_INHSE_LOG_WALKIN_ACTIVITY",
  WEB_INHSE_IN_HOUSE_VIEW = "WEB_INHSE_IN_HOUSE_VIEW",
  WEB_USRS_LIST_VIEW = "WEB_USRS_LIST_VIEW",
  WEB_USRS_LIST_SEARCH = "WEB_USRS_LIST_SEARCH",
  WEB_USRS_USR_ADD_INVITE = "WEB_USRS_USR_ADD_INVITE",
  WEB_USRS_USR_VIEW = "WEB_USRS_USR_VIEW",
  WEB_USRS_USR_EDIT = "WEB_USRS_USR_EDIT",
  WEB_USRS_USR_DELETE = "WEB_USRS_USR_DELETE",
  WEB_USRS_USR_RESEND_LINK = "WEB_USRS_USR_RESEND_LINK",
  WEB_SIGN_OUT_OK = "WEB_SIGN_OUT_OK",
  WEB_SIGN_OUT_TIMEOUT = "WEB_SIGN_OUT_TIMEOUT",
  CHAT_CONTACTS_VIEW = "CHAT_CONTACTS_VIEW",
  CHAT_MESSAGES_VIEW = "CHAT_MESSAGES_VIEW",
  WEB_COLORS_LIST_VIEW = "WEB_COLORS_LIST_VIEW",
  WEB_COLORS_AUDIT_LOG_VIEW = "WEB_COLORS_AUDIT_LOG_VIEW",
  WEB_COLORS_ADD = "WEB_COLORS_ADD",
  WEB_COLORS_EDIT = "WEB_COLORS_EDIT",
  WEB_COLORS_DELETE = "WEB_COLORS_DELETE",
  WEB_COLORS_BATCH_UPLOAD = "WEB_COLORS_BATCH_UPLOAD",
  WEB_PART_ENTER_CASE_PLAN = "WEB_PART_ENTER_CASE_PLAN",
  WEB_PART_ADDED_CASE_PLAN = "WEB_PART_ADDED_CASE_PLAN",
  WEB_PART_DELETED_CASE_PLAN = "WEB_PART_DELETED_CASE_PLAN",
  WEB_OU_LIST_VIEW = "WEB_OU_LIST_VIEW",
  WEB_OU_ADD = "WEB_OU_ADD",
  WEB_OU_EDIT = "WEB_OU_EDIT",
  WEB_OU_DELETE = "WEB_OU_DELETE",
  WEB_PROG_LIST_VIEW = "WEB_PROG_LIST_VIEW",
  WEB_PROG_LIST_SEARCH = "WEB_PROG_LIST_SEARCH",
  WEB_PROG_ADD = "WEB_PROG_ADD",
  WEB_PROG_EDIT = "WEB_PROG_EDIT",
  WEB_PROG_DELETE = "WEB_PROG_DELETE",
  WEB_ROLES_LIST_VIEW = "WEB_ROLES_LIST_VIEW",
  WEB_ROLES_LIST_SEARCH = "WEB_ROLES_LIST_SEARCH",
  WEB_ROLES_ADD = "WEB_ROLES_ADD",
  WEB_ROLES_EDIT = "WEB_ROLES_EDIT",
  WEB_ROLES_DELETE = "WEB_ROLES_DELETE",
  WEB_ROLES_AUDIT_LOG_VIEW = "WEB_ROLES_AUDIT_LOG_VIEW",
  WEB_ENR_PART_PROG = "WEB_ENR_PART_PROG",
  WEB_ENR_PART_DIS = "WEB_ENR_PART_DIS",
  WEB_ENR_PART_EDIT = "WEB_ENR_PART_EDIT",
  WEB_PART_ENROLL_ADD_ENTER = "WEB_PART_ENROLL_ADD_ENTER",
  WEB_PART_ENROLL_ADDED = "WEB_PART_ENROLL_ADDED",
  WEB_PART_ENROLL_EDIT_ENTER = "WEB_PART_ENROLL_EDIT_ENTER",
  WEB_PART_ENROLL_EDITED = "WEB_PART_ENROLL_EDITED",

  WEB_ENR_PART_DETAIL_TEST = "WEB_ENR_PART_DETAIL_TEST",
  WEB_ENR_PART_DETAIL_TEST_VAL_RESULT_VIEW = "WEB_ENR_PART_DETAIL_TEST_VAL_RESULT_VIEW",
  WEB_PART_ENROLL_RESULTS_VIEWED = "WEB_PART_ENROLL_RESULTS_VIEWED",
  WEB_ENR_PART_ONDEMAND_INC = "WEB_ENR_PART_ONDEMAND_INC",
  WEB_ENR_PART_DETAIL_INC = "WEB_ENR_PART_DETAIL_INC",
  WEB_DASH_VIEW = "WEB_DASH_VIEW",

  WEB_ACTIONS_LIST_VIEW = "WEB_ACTIONS_LIST_VIEW",
  WEB_ACTIONS_VIEW = "WEB_ACTIONS_VIEW",
  WEB_ACTIONS_SEARCH = "WEB_ACTIONS_SEARCH",
  WEB_ACTIONS_CREATE = "WEB_ACTIONS_CREATE",
  WEB_ACTIONS_EDIT = "WEB_ACTIONS_EDIT",
  WEB_ACTIONS_DELETE = "WEB_ACTIONS_DELETE",

  WEB_SETTINGS_LIST_VIEW = "WEB_SETTINGS_LIST_VIEW",
  WEB_SETTINGS_VIEW = "WEB_SETTINGS_VIEW",
  WEB_SETTINGS_SEARCH = "WEB_SETTINGS_SEARCH",
  WEB_SETTINGS_CREATE = "WEB_SETTINGS_CREATE",
  WEB_SETTINGS_EDIT = "WEB_SETTINGS_EDIT",
  WEB_SETTINGS_DELETE = "WEB_SETTINGS_DELETE",

  WEB_GROUP_LABEL_LIST_VIEW = "WEB_GROUP_LABEL_LIST_VIEW",
  WEB_GROUP_LABEL_VIEW = "WEB_GROUP_LABEL_VIEW",
  WEB_GROUP_LABEL_SEARCH = "WEB_GROUP_LABEL_SEARCH",
  WEB_GROUP_LABEL_CREATE = "WEB_GROUP_LABEL_CREATE",
  WEB_GROUP_LABEL_EDIT = "WEB_GROUP_LABEL_EDIT",
  WEB_GROUP_LABEL_DELETE = "WEB_GROUP_LABEL_DELETE",

  EDUCATIONAL_RESOURCES_VIEW = "EDUCATIONAL_RESOURCES_VIEW",
  EDUCATIONAL_RESOURCES_SEARCH = "EDUCATIONAL_RESOURCES_SEARCH",
  EDUCATIONAL_RESOURCES_CREATE = "EDUCATIONAL_RESOURCES_CREATE",
  EDUCATIONAL_RESOURCES_EDIT = "EDUCATIONAL_RESOURCES_EDIT",
  EDUCATIONAL_RESOURCES_DELETE = "EDUCATIONAL_RESOURCES_DELETE",

  // Export data (backoffice research export)
  WEB_EXPORT_DATA_VIEW = "WEB_EXPORT_DATA_VIEW",
  WEB_EXPORT_DATA_SUBMIT = "WEB_EXPORT_DATA_SUBMIT",
}
